import { Card, CardHeader, Stack, IconButton, Tooltip, ButtonGroup } from "@mui/material";
import DashboardLayout from "../layoutcontainers/DashboardLayout";
import MaterialButton from "../components/MaterialButton";
import AddIcon from "@mui/icons-material/Add";
import { IoCloseCircleOutline } from "react-icons/io5";
import MaterialTypography from "../components/MaterialTypography";
import MaterialSelect from "../components/MasterSelect";
import { useEffect, useState } from "react";
import MaterialBox from "../components/MaterialBox";
import MaterialDataGrid from "../components/MaterialDataGrid";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import BASEURL from "../pages/Utils/Baseurl";
import ConfirmationDialog from "../components/Dialog/ConfirmationDialog";
import { Allstaffrequestquery } from "./Graphql";
import { apicall } from "../Integration/apicall";
import { FaFilter } from "react-icons/fa";
import { IoRefreshCircle } from "react-icons/io5";
import { getalldepartment, getallrecruitmentprocess, getjobids } from "./query";
import RequestDialog from "./requestdialog";
import { FaRegCheckCircle } from "react-icons/fa";
import AnimatedClockIcon from "../components/Icon/animatedClockIcon";
import ReusableFilter from "../ReusableFilter";

const RecrruitmentTable = () => {
  const nav = useNavigate();
  const [currentrequest, setcurrentrequest] = useState("");
  const [RecruitmentRows, setRecruitmentRows] = useState([]);
  const [Sampledata] = useState([]);
  const [tabledata, settabledata] = useState([]);
  const [Staffdata, setStaffdata] = useState([]);
   const [filterparam, setfilterparam] = useState([]);
  const [recruitmentdata, setrecruitmentdata] = useState({});
    const [openfilter, setopenfilter] = useState(false);



  const [filterdep, setfilterdep] = useState({ value: "All", label: "All" });
  const [statusdata, setstatusdata] = useState({ value: "All", label: "All" });
  const [alljobid, setalljobid] = useState([]);

  const [sampledata, setsampledata] = useState([]);
  const [departmentdata, setdepartmentdata] = useState([]);
  const jobstatus = [
    { value: "All", label: "All" },
    { value: "Open", label: "Open" },
    { value: "Closed", label: "Closed" },
    { value: "Hold", label: "Hold" },



  ];

    useEffect(() => {
      Promise.all([apicall(getalldepartment), apicall(getjobids)]).then(
        ([departmentdata, jobdata]) => {
          console.log("department res", departmentdata?.data?.data);
          console.log("job res", jobdata?.data?.data);
          let departments = departmentdata?.data?.data?.allDepartment;
          let jobs = jobdata?.data?.data?.allStaffRequests;
          console.log(jobs, "alljobs found");
  
          jobs = jobs?.map((job) => ({
            value: job?.jobid,
            label: job?.jobid,
            field: "jobid",
          }));
  
          departments = departments?.map((department) => ({
            value: department?.departmentName,
            label: department?.departmentName,
            field: "department",
          }));
  
          setfilterparam([
            {
              field: "JobId",
              options: jobs,
            },
            {
              field: "department",
              options: departments,
            },
          ]);
        }
      );
    }, []);
   
  const handleclick = () => {
    nav("/recruitment/manually-added-candidate");
  };

  const handlecurrentrequest = (request, data) => {
    console.log(data, "requesteddata");
    setrecruitmentdata({});
    setcurrentrequest(request);
    setrecruitmentdata((prev) => ({
      ...prev,
      //payslip details
      payslipurl: data?.recruitmentProcess?.payslipFile,
      payslipname:
        data?.recruitmentProcess?.payslipFile.split("/").pop() ||
        "No File Choosen",
      recruitmentprocessid: data?.recruitmentProcess?.id,
      staffrequestid: data?.staffRequest?.id,
      technicalfeedbackid: data?.technicalFeedback?.id,
      sourcingscreeningid: data?.technicalFeedback?.sourcingScreening?.id,

      screening: data?.recruitmentProcess?.screening ?? false,
      technicalInterview: data?.recruitmentProcess?.technicalInterview ?? false,
      interviewStatus: data?.recruitmentProcess?.interviewStatus ?? false,
      offerLetter: data?.recruitmentProcess?.offerLetter ?? false,
      onBording: data?.recruitmentProcess?.onBording ?? false,
      assertRequest: data?.recruitmentProcess?.assertRequest ?? false,
      documentVerification:
        data?.recruitmentProcess?.documentVerification ?? false,
      appointmentLetter: data?.recruitmentProcess?.appointmentLetter ?? false,
      nda: data?.recruitmentProcess?.nda ?? false,
      hrInduction: data?.recruitmentProcess?.hrInduction ?? false,
      technicalInduction: data?.recruitmentProcess?.technicalInduction ?? false,
      teamIntro: data?.recruitmentProcess?.teamIntro ?? false,
      assestHandover: data?.recruitmentProcess?.assestHandover ?? false,
      hrmsAccess: data?.recruitmentProcess?.hrmsAccess ?? false,
      handoverToManager: data?.recruitmentProcess?.handoverToManager ?? false,

      //offer details
      offerid: data?.recruitmentProcess?.offerSalary?.[0]?.id || 0,
      ctc: data?.recruitmentProcess?.offerSalary?.[0]?.ctc || 0,
      CtcStatus: data?.recruitmentProcess?.offerSalary?.[0]?.ctc
        ? "success"
        : "unchecked",
      basicPercentage:
        data?.recruitmentProcess?.offerSalary?.[0]?.basicPercentage,
      basicPercentageStatus: data?.recruitmentProcess?.offerSalary?.[0]
        ?.basicPercentage
        ? "success"
        : "unchecked",
      salarystructure: {
        value: data?.recruitmentProcess?.offerSalary?.[0]?.salaryStructure?.id,
        label:
          data?.recruitmentProcess?.offerSalary?.[0]?.salaryStructure
            ?.structureName,
      },
      salarystructureStatus: data?.recruitmentProcess?.offerSalary?.[0]
        ?.salaryStructure?.id
        ? "success"
        : "unchecked",
      joiningdate: data?.recruitmentProcess?.offerSalary?.[0]?.date,
      joiningdateStatus: data?.recruitmentProcess?.offerSalary?.[0]?.date
        ? "success"
        : "unchecked",
    }));
    setOpen(true);
  };
    const handleclosefilter = () => {
    setopenfilter(false);
  };
  //Handle change for all dialog boxes
  const handlerecruitmentchange = (field, value) => {
    setrecruitmentdata((prev) => ({
      ...prev,
      [field]: value,
    }));
    console.log("handlerecruitmentchange:", field, value);
    switch (field) {
      //Offer Letter
      case "ctc":
        const alphaNumericRegex = /^[0-9]{4,15}$/;
        if (alphaNumericRegex.test(value)) {
          setrecruitmentdata((prev) => ({
            ...prev,
            CtcStatus: "success",
          }));
        } else {
          setrecruitmentdata((prev) => ({
            ...prev,
            CtcStatus: "error",
          }));
        }
        break;
      case "salarystructure":
        if (value) {
          setrecruitmentdata((prev) => ({
            ...prev,
            salarystructureStatus: "success",
          }));
        } else {
          setrecruitmentdata((prev) => ({
            ...prev,
            salarystructureStatus: "error",
          }));
        }
        break;
      case "joiningdate":
        const dateRegex = /^\d{4}-\d{2}-\d{2}$/; // YYYY-MM-DD format
        if (dateRegex.test(value)) {
          setrecruitmentdata((prev) => ({
            ...prev,
            joiningdateStatus: "success",
          }));
        }
        break;

      case "basicPercentage":
        const alphaNumericRegexBasic = /^[0-9]{1,2}$/;
        if (alphaNumericRegexBasic.test(value)) {
          setrecruitmentdata((prev) => ({
            ...prev,
            basicPercentageStatus: "success",
          }));
        } else {
          setrecruitmentdata((prev) => ({
            ...prev,
            basicPercentageStatus: "error",
          }));
        }
        break;

      //On Boarding
      case "onboardtoemail":
        if (value) {
          setrecruitmentdata((prev) => ({
            ...prev,
            todataStatus: "success",
          }));
        } else {
          setrecruitmentdata((prev) => ({
            ...prev,
            todataStatus: "error",
          }));
        }
        break;
      case "onboardccmail":
        if (Array.isArray(value) && value.length > 0) {
          setrecruitmentdata((prev) => ({
            ...prev,
            onboardccmailStatus: "success",
          }));
        } else {
          setrecruitmentdata((prev) => ({
            ...prev,
            onboardccmailStatus: "error",
          }));
        }
        break;
      case "onboardcontent":
        const alphaNumericRegexContent = /^[a-zA-Z0-9\s.,!?-]{1,300}$/;
        if (alphaNumericRegexContent.test(value)) {
          setrecruitmentdata((prev) => ({
            ...prev,
            contentStatus: "success",
          }));
        } else {
          setrecruitmentdata((prev) => ({
            ...prev,
            contentStatus: "error",
          }));
        }
        break;

      //Asset Request
      case "assetName":
        const alphaNumericRegexAssetName = /^[a-zA-Z0-9\s.,!?-]{1,50}$/;
        if (alphaNumericRegexAssetName.test(value)) {
          setrecruitmentdata((prev) => ({
            ...prev,
            assetNameStatus: "success",
          }));
        } else {
          setrecruitmentdata((prev) => ({
            ...prev,
            assetNameStatus: "error",
          }));
        }
        break;

      case "assetcharge":
        if (value) {
          setrecruitmentdata((prev) => ({
            ...prev,
            assetchargeStatus: "success",
          }));
        } else {
          setrecruitmentdata((prev) => ({
            ...prev,
            assetchargeStatus: "error",
          }));
        }
        break;

      case "assetcc":
        console.log("success");

        if (Array.isArray(value) && value.length > 0) {
          setrecruitmentdata((prev) => ({
            ...prev,
            assetccStatus: "success",
          }));
        } else {
          setrecruitmentdata((prev) => ({
            ...prev,
            assetccStatus: "error",
          }));
        }
        break;

      case "remaindertime":
        if (value && value.trim() !== "") {
          setrecruitmentdata((prev) => ({
            ...prev,
            remaindertimeStatus: "success",
          }));
        } else {
          setrecruitmentdata((prev) => ({
            ...prev,
            remaindertimeStatus: "error",
          }));
        }
        break;

      case "assetcontent":
        const alphaNumericRegexReminder = /^[a-zA-Z0-9\s.,!?-]{1,300}$/;
        if (alphaNumericRegexReminder.test(value)) {
          setrecruitmentdata((prev) => ({
            ...prev,
            ContentStatus: "success",
          }));
        } else {
          setrecruitmentdata((prev) => ({
            ...prev,
            ContentStatus: "error",
          }));
        }
        break;
    }
  };



 


  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });



 


  const RecruitmentColumns = [
    {
      field: "jobid",
      headerName: "Job ID",
      width: 90,
      disableColumnMenu: true,
      editable: false,
      sortable: true,
    },
    {
      field: "candidateName",
      headerName: "Name",
      width: 140,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
    },
    {
      field: "position",
      headerName: "Position",
      width: 180,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
    },
    {
      field: "hirringstatus",
      headerName: "Status",
      width: 110,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
    },

    {
      field: "payslip",
      headerName: "Payslip Verification",
      width: 150,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
    },

    {
      field: "offerLetter",
      headerName: "Offer Letter",
      width: 130,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
    },

    {
      field: "OnBoarding",
      headerName: "OnBoarding",
      width: 130,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
    },

    {
      field: "assertRequest",
      headerName: "Asset Request",
      width: 130,
      editable: false,
      disableColumnMenu: true,
      sortable: true,
    },
  ];

  const departmentName = [
    {
      id: "HR",
      departmentName: "hr",
    },

    {
      id: "Dev",
      departmentName: "dev",
    },

    {
      id: "DEV",
      departmentName: "dev",
    },
  ];

  departmentName.forEach((data) => console.log(data));

  const [open, setOpen] = useState(false);







  useEffect(() => {
    getrecruitmentprocess();
  }, []);

  const getrecruitmentprocess = () => {
    apicall(getallrecruitmentprocess)
      .then((res) => {
        if (res?.success) {
          console.log(
            res?.data?.data?.allRecruitmentAndHiredFeedback,
            "recdataa"
          );

          let recruitment_data =
            res?.data?.data?.allRecruitmentAndHiredFeedback;
          recruitment_data = recruitment_data?.map((recruitment, ind) => ({
            id: ind + 1,
            recruitment_id: recruitment?.recruitmentProcess?.id || -1,
            jobid: recruitment?.technicalFeedback?.sourcingScreening?.jobid,
            candidateName:
              recruitment?.technicalFeedback?.sourcingScreening?.candidateName,
            position:
              recruitment?.technicalFeedback?.sourcingScreening?.position,
                          department:
              recruitment?.technicalFeedback?.sourcingScreening?.department,
            hirringstatus: recruitment?.technicalFeedback?.hiringStatus,
            payslip: recruitment?.recruitmentProcess?.payslipFile ? (
              <td
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <IconButton
                  onClick={() => handlecurrentrequest("Payslip", recruitment)}
                  sx={{
                    transition: "transform 1.0s ease",
                    "&:hover": {
                      transform: "scale(1.4)",
                    },
                  }}
                >
                  <FaRegCheckCircle color="green" size={20} />
                </IconButton>
              </td>
            ) : (
              <td
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <IconButton
                  onClick={() => handlecurrentrequest("Payslip", recruitment)}
                  sx={{
                    transition: "transform 1.0s ease",
                    "&:hover": {
                      transform: "scale(1.4)",
                    },
                  }}
                >
                  <AnimatedClockIcon size={20} color="#FF6F00" />
                </IconButton>
              </td>
            ),

            offerLetter: recruitment?.recruitmentProcess?.offerLetter ? (
              <td
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <IconButton
                  onClick={() => handlecurrentrequest("Offer", recruitment)}
                  sx={{
                    transition: "transform 1.0s ease",
                    "&:hover": {
                      transform: "scale(1.4)",
                    },
                  }}
                >
                  <FaRegCheckCircle color="green" size={20} />
                </IconButton>
              </td>
            ) : (
              <td
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <IconButton
                  onClick={() => handlecurrentrequest("Offer", recruitment)}
                  sx={{
                    transition: "transform 1.0s ease",
                    "&:hover": {
                      transform: "scale(1.4)",
                    },
                  }}
                >
                  <AnimatedClockIcon size={20} color="#FF6F00" />
                </IconButton>
              </td>
            ),
            OnBoarding: recruitment?.recruitmentProcess?.onBording ? (
              <td
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <IconButton
                  onClick={() =>
                    handlecurrentrequest("Onboarding", recruitment)
                  }
                  sx={{
                    transition: "transform 1.0s ease",
                    "&:hover": {
                      transform: "scale(1.4)",
                    },
                  }}
                >
                  <FaRegCheckCircle color="green" size={20} />
                </IconButton>
              </td>
            ) : (
              <td
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <IconButton
                  onClick={() =>
                    handlecurrentrequest("Onboarding", recruitment)
                  }
                  sx={{
                    transition: "transform 1.0s ease",
                    "&:hover": {
                      transform: "scale(1.4)",
                    },
                  }}
                >
                  <AnimatedClockIcon size={20} color="#FF6F00" />
                </IconButton>
              </td>
            ),

            assertRequest: recruitment?.recruitmentProcess?.assertRequest ? (
              <td
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <IconButton
                  onClick={() =>
                    handlecurrentrequest("assetrequest", recruitment)
                  }
                  sx={{
                    transition: "transform 1.0s ease",
                    "&:hover": {
                      transform: "scale(1.4)",
                    },
                  }}
                >
                  <FaRegCheckCircle color="green" size={20} />
                </IconButton>
              </td>
            ) : (
              <td
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <IconButton
                  onClick={() =>
                    handlecurrentrequest("assetrequest", recruitment)
                  }
                  sx={{
                    transition: "transform 1.0s ease",
                    "&:hover": {
                      transform: "scale(1.4)",
                    },
                  }}
                >
                  <AnimatedClockIcon size={20} color="#FF6F00" />
                </IconButton>
              </td>
            ),
          }));

          setRecruitmentRows(recruitment_data);
        } else {
          alert("Something Went Wrong Try After Sometime !");
        }
      })
      .catch((err) => {
        alert("Cannot Able to Recruitment Data ", err?.message);
      });
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      <Card>
        <CardHeader
          title={
            <>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
                margin={1}
              >
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                    Recruitment Details
                  </MaterialTypography>
                </Stack>

                  <Stack direction="row">
                                  <ButtonGroup variant="outlined" size="small" color="#000">
                                    <Tooltip title="Filter the table" disableInteractive arrow>
                                      <MaterialButton onClick={() => setopenfilter(true)}>
                                        <FaFilter size={16} color="black" />
                                      </MaterialButton>
                                    </Tooltip>
                                    <Tooltip title="Refresh/Reset the table" disableInteractive arrow>
                                      <MaterialButton onClick={getrecruitmentprocess}>
                                        <IoRefreshCircle size={20} color="black" />
                                      </MaterialButton>
                                    </Tooltip>
                                  </ButtonGroup>
                                </Stack>

                <Stack direction="row" spacing={1}>
                  <Stack direction="row" spacing={1}>
                    {/* Process Completed */}
                    <Tooltip
                      title="This indicates that the process or action has been successfully completed."
                      disableInteractive
                      arrow
                    >
                      <MaterialBox
                        sx={{
                          border: "1px solid #e0e0e0",
                          borderRadius: 4,
                          px: 1.5,
                          py: 0.5,
                          display: "flex",
                          alignItems: "center",
                          gap: 0.8,
                          backgroundColor: "#f9f9f9",
                          transition:
                            "transform 0.2s ease-in-out, box-shadow 0.2s",
                          cursor: "default",
                          "&:hover": {
                            transform: "translateY(-2px)",
                            boxShadow: "0 2px 10px rgba(0, 128, 0, 0.2)",
                            backgroundColor: "#e6ffe6",
                          },
                        }}
                      >
                        <FaRegCheckCircle color="green" size={20} />
                        <MaterialTypography
                          variant="caption"
                          color="text.secondary"
                        >
                          Process Completed
                        </MaterialTypography>
                      </MaterialBox>
                    </Tooltip>

                    {/* Pending Progress */}
                    <Tooltip
                      title="This indicates that the process is still pending and requires action to be completed."
                      disableInteractive
                      arrow
                    >
                      <MaterialBox
                        sx={{
                          border: "1px solid #e0e0e0",
                          borderRadius: 4,
                          px: 1.5,
                          py: 0.5,
                          display: "flex",
                          alignItems: "center",
                          gap: 0.8,
                          backgroundColor: "#f9f9f9",
                          transition:
                            "transform 0.2s ease-in-out, box-shadow 0.2s",
                          cursor: "default",
                          "&:hover": {
                            transform: "translateY(-2px)",
                            boxShadow: "0 2px 10px rgba(255, 111, 0, 0.2)",
                            backgroundColor: "#fff5e6",
                          },
                        }}
                      >
                        <AnimatedClockIcon size={20} color="#FF6F00" />
                        <MaterialTypography
                          variant="caption"
                          color="text.secondary"
                        >
                          Pending Progress
                        </MaterialTypography>
                      </MaterialBox>
                    </Tooltip>
                  </Stack>

                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    startIcon={<AddIcon />}
                    onClick={handleclick}
                  >
                    Manually Add Candidate
                  </MaterialButton>
                </Stack>
              </Stack>
            </>
          }
        />
        <MaterialDataGrid
        
          rows={RecruitmentRows}
          columns={RecruitmentColumns}
          checkboxSelection={false}
          isSelectable={false}
          onRowClick={""}
          localeText={{
            noRowsLabel: (
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={1}
              >
                <MaterialTypography
                  variant="body2"
                  fontWeight="medium"
                  color="text"
                >
                  No recruitment details found
                </MaterialTypography>
                <MaterialTypography variant="caption" color="text">
                  You have not yet add any recruitment details.
                </MaterialTypography>
              </Stack>
            ),
          }}
        />
      </Card>
      <MaterialBox>
        <RequestDialog
          open={open}
          setOpen={setOpen}
          currentrequest={currentrequest}
          recruitmentdata={recruitmentdata}
          handlerecruitmentchange={handlerecruitmentchange}
          setrecruitmentdata={setrecruitmentdata}
          confirmationDialog={confirmationDialog}
          setConfirmationDialog={setConfirmationDialog}
          getrecruitmentprocess={getrecruitmentprocess}
        />

          <ReusableFilter
                  filterparam={filterparam}
                  setfilterparam={setfilterparam}
                  setfilterdata={setRecruitmentRows}
                  openfilter={openfilter}
                  handleclosefilter={handleclosefilter}
                  unfiltereddata={RecruitmentRows}
                />
      </MaterialBox>


    </DashboardLayout>
  );
};
export default RecrruitmentTable;
